import { render, staticRenderFns } from "./orderRecord.vue?vue&type=template&id=ec95ba2e&scoped=true&"
import script from "./orderRecord.vue?vue&type=script&lang=js&"
export * from "./orderRecord.vue?vue&type=script&lang=js&"
import style0 from "./orderRecord.vue?vue&type=style&index=0&id=ec95ba2e&scoped=true&lang=css&"
import style1 from "./orderRecord.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec95ba2e",
  null
  
)

export default component.exports